<template>
  <div class='invite'>
    <LoginForm
      v-if="existingUser && email"
      v-bind:foundEmail="email"
    />
    <SignUpForm
      v-else-if="email"
      v-bind:foundEmail="email"
    />
    <InvitationExpiredMessage
      v-if="expiredMessage"
    />
  </div>
</template>

<script>
import LoginForm from '@/components/onboard/LoginForm.vue'
import SignUpForm from '@/components/onboard/SignUpForm.vue'
import InvitationExpiredMessage from '@/components/onboard/InvitationExpiredMessage.vue'

import { userService } from '@/services/user.service'

export default {
  name: 'Invite',
  components: {
    LoginForm,
    SignUpForm,
    InvitationExpiredMessage
  },
  data: function () {
    return {
      email: '',
      existingUser: false,
      expiredMessage: false
    }
  },
  created: async function () {
    await this.checkToken()
  },
  methods: {
    checkToken: function () {
      return new Promise(async (resolve) => {
        let token = {}

        if(localStorage.getItem('groupInvite')) {
          token.type = 'group'
          token.token = localStorage.getItem('groupInvite')
        }
        else {
          token.type = 'plan'
          token.token = localStorage.getItem('planInvite')
        }

        await userService.testToken(token).then(res => {
          this.email = res.emailAddress
          this.existingUser = res.existingUser
        }).catch(err => {
          this.expiredMessage = true
          console.error('Unable to lookup token: ', err)
        })

        resolve()
      })
    }
  }
}
</script>
